import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  let priority = useDataValue({
    context: 'priority',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_task_priority',
      task_id,
      priority,
    })
  }
}
